;(function ( $ ) {

    /**
     *  confirm
     *  show custom confirmation dialog
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'confirm';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {
            this.registerEvents();
            this.headline = $(this.element).data('headline');
            this.captionCancel = $(this.element).data('text-cancel');
            this.captionOk = $(this.element).data('text-ok');
            this.$overlay = $('<div class="overlay-confirm" style="z-index: 9990;"><div class="overlay-confirm-bg"></div><div class="overlay-confirm-content bg-color-event"></div></div>');
            this.$overlay.find('.overlay-confirm-content').append('<h1>' + this.headline + '</h1>');
            this.$overlay.find('.overlay-confirm-content').append('<button type="button" class="confirm-cancel button button-outline color-event-fg border-color-event-fg bg-color-event-fg-hover min-width-300">' + this.captionCancel + '</button>');
            this.$overlay.find('.overlay-confirm-content').append('<button type="button" class="confirm-ok button bg-color-event-fg min-width-300">' + this.captionOk + '</button>');
            this.$overlay.find('.overlay-confirm-content').append('<a href="#" class="close color-event-fg"><span class="icon icon-close"></span></a>');
        },

        registerEvents: function() {
            var _this = this;
            $(this.element).on('click', function(e) {
                console.log(e);
                e.preventDefault();
                _this.showOverlay();
            });
            $(document).keyup(function(e) {
                if (e.keyCode == 27) { // escape
                    _this.hideOverlay();
                }
            });
            $('body').on('click', '.overlay-confirm-content .close', function(e) {
                e.preventDefault();
                _this.hideOverlay();
            });
            $('body').on('click', '.overlay-confirm-content .confirm-cancel', function(e) {
                e.preventDefault();
                _this.hideOverlay();
            });

            $('body').on('click', '.overlay-confirm-content .confirm-ok', function(e) {
                // TODO - execute OK action
                e.preventDefault();
                _this.hideOverlay();
            });
        },

        showOverlay: function() {
            $('body').append(this.$overlay);
            $('body').addClass('noscroll');
        },

        hideOverlay: function() {
            $('body').find('.overlay-confirm').remove();
            $('body').removeClass('noscroll');
        }

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
